module.exports = __webpack_public_path__ + "img/table-delete-icon-white.6fc08c8c.svg";